<template>
  <vs-chip v-if="status" :color="status.color" :class="$style.container">
    {{ status.name }}
  </vs-chip>
</template>

<script>
import actStatuses from "@/dictionaries/actStatuses";

export default {
  name:    "ActStatus",
  props:   ['id'],
  data() {
    return {
      status: null,
    };
  },
  methods: {
    loadStatus() {
      actStatuses.getById(this.id).then(( status ) => {
        this.status = status;
      });
    },
  },
  mounted() {
    this.loadStatus();
  },
  watch:   {
    id() {
      this.loadStatus();
    },
  },
};
</script>

<style lang="scss" module>
.container {
  width: 250px;
  border-radius: 0;
}
</style>
